<div class="formgrid grid">
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-dropdown inputId="tipo_data" [options]="datas" [(ngModel)]="dataSelecionada" placeholder="Filtro data" optionLabel="nome" [showClear]="false" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'" (onChange)="onTipoDataChange(($event))"></p-dropdown>
    </div>
  
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-calendar inputId="date" [(ngModel)]="date" [disabled]="dataSelecionada.id == 0" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Data inicio" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
    </div>
  
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-calendar inputId="dateEnd" [(ngModel)]="dateEnd" [disabled]="dataSelecionada.id == 0" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Data final" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
    </div>
  </div>
  
  <div class="formgrid grid">
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-dropdown inputId="status" [options]="status" [(ngModel)]="statusSelecionado" placeholder="Status" optionLabel="nome" [showClear]="false" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'"></p-dropdown>
    </div>
  
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-dropdown inputId="localizacao" [options]="localizacoes" [(ngModel)]="localizacaoSelecionada" placeholder="Localização" optionLabel="nome" [showClear]="true" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'"></p-dropdown>
    </div>
  
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-dropdown inputId="filtro" [options]="filtros" [(ngModel)]="filtroSelecionada" placeholder="Filtro campos" optionLabel="nome" [showClear]="true" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'"></p-dropdown>
    </div>
  
    <div class="field col-12 sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <input [(ngModel)]="valorFiltro" pInputText type="text" placeholder="Valor filtro campos" [style]="{'width':'100%'}" [ngClass]="'p-inputtext-sm'" />
    </div>
  
    <div class="field col sm:col-12 lg:col-2 md:col-2 xl:col-2">
      <p-button type="button" label="Filtrar" size="small" (click)="aplicarFiltro()"></p-button>
    </div>
  </div>